import React, { useState } from 'react';

import Modal from 'components/cosmos/modal';
import Icon from 'components/icons';
import StaticLink from 'components/staticLink/StaticLink';
import { ReactComponent as Alarm } from 'components/svg/icons/alarm.svg';
import { ReactComponent as PaperPlane } from 'components/svg/icons/paper-plane.svg';
import { ReactComponent as UsersCosmos } from 'components/svg/icons/users-cosmos.svg';
import I18n from 'components/translate/I18n';
import { STATIC_LINKS } from 'modules/dashboard/constants';
import PropTypes from 'prop-types';

import './PublishAndNotifyModal.scss';

const PublishAndNotifyInfo = ({ className = '', icon, label, ...context }) => (
  <p className={`${className} _d-flex _mb-4`}>
    {icon}
    <I18n html label={label} data={context} />
  </p>
);

PublishAndNotifyInfo.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired
};

const PublishAndNotifyModal = ({
  isOpen,
  productName,
  onConfirm,
  onCancel
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const header = (
    <h3 className="_text-4 _text-gray-700 _mb-3">
      <I18n label="content_list.email_notification.title" />
    </h3>
  );

  const footer = (
    <div className="_d-flex _justify-content-center _justify-content-md-end _w-full">
      <button
        className="hot-button hot-button--secondary _mr-4"
        data-test="cancel-button"
        onClick={onCancel}
      >
        <I18n label="general.cancel" />
      </button>
      <button
        className="hot-button hot-button--primary"
        data-test="confirm-button"
        onClick={() => onConfirm(dontShowAgain)}
      >
        <I18n label="content_list.email_notification.publish_notify" />
      </button>
    </div>
  );

  return (
    <Modal
      className="email-notification"
      header={header}
      footer={footer}
      open={isOpen}
      onClose={onCancel}
      headerClass="_pb-0"
      bodyClass="_pt-0 _pb-4"
    >
      <p className="_mb-6 _mb-sm-7 _mt-0 _text-2 _text-gray-500">
        <I18n label="content_list.email_notification.subtitle" />{' '}
        <StaticLink
          links={STATIC_LINKS.PUBLISH_AND_NOTIFY}
          className="know-more-link _text-blue-dark"
        >
          <I18n label="general.know_more" />{' '}
          <Icon prefix="far" iconName="arrow-right" />
        </StaticLink>
      </p>
      <PublishAndNotifyInfo
        className="_mt-0"
        icon={<PaperPlane className="_mr-4 paper-plane-icon" />}
        label="content_list.email_notification.info1"
      />
      <PublishAndNotifyInfo
        icon={<Alarm className="_mr-4 icon" />}
        label="content_list.email_notification.info2"
        amount={1}
        hours={24}
      />
      <PublishAndNotifyInfo
        className="_mb-0"
        icon={<UsersCosmos className="_mr-4 icon users-icon" />}
        label="content_list.email_notification.info3_new"
        product={productName}
      />

      <div className="hot-form hot-form--custom hot-form--checkbox _mt-6 _mt-sm-7 _mb-2 _mb-sm-4">
        <input
          type="checkbox"
          className="hot-form__input"
          id="dont-show-again"
          checked={dontShowAgain}
          onChange={() => setDontShowAgain(!dontShowAgain)}
        />
        <label className="hot-form__label _mt-0" htmlFor="dont-show-again">
          <I18n label="content_list.email_notification.dont_show_again" />
        </label>
      </div>
    </Modal>
  );
};

PublishAndNotifyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  productName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default PublishAndNotifyModal;
